import { render } from "./myClass.vue?vue&type=template&id=3412aca0"
import script from "./myClass.vue?vue&type=script&lang=js"
export * from "./myClass.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/xxzx-website-county_fx0Z/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__